<template>
  <div>
    <gameOver v-if="showOver" :score="gameScore" :gameFlag="gameType" :tempFlag="1" @restart="restartTrain" @close="closeGame"></gameOver>
      <mu-dialog :open="showDialog" dialogClass="diaTrainContent">
      <!-- <img src="../../../assets/img/icon_close.png" /> -->
      <mu-row style='height:320px'>
        <mu-col desktop="40">
          <mu-paper :zDepth="1" style="width:240px;height:240px;">
            <img :src="address+game.image" style="width:240px;height:240px;" />
                <span class="bold-content" style='font-size:16px;font-weight: bolder;'><b>{{ game.name }}</b></span>
             </br>
              <span v-for="item in game.label_desc"  style='font-size:14px;padding-top:20px;color:black;'>{{item.name}}&nbsp;&nbsp;</span>
          </mu-paper>
        </mu-col>
        <mu-col desktop="60">
          <mu-row>
            <mu-col style='height:300px'>
              <!--<mu-row><mu-col>
                <span class="title-style">应用名称</span><br>
                <span class="bold-content"><b>{{ game.name }}</b></span>
                <level :level="game.level"></level>
               
              </mu-col></mu-row>
              
              <mu-row class="canWidth">
                <mu-col desktop="40">
                  <span class="title-style">训练时长</span><br>
                  <span v-if="game.id<100" class="bold-content">{{game.duration/60}}分钟</span>
                  <span v-else class="bold-content">10分钟</span>
                </mu-col>
                <mu-col desktop="60">
                  <div v-if="game.id>100">
                    <span class="title-style">对应脑能力</span><br>
                    <span v-for="item in game.label_desc" class="bold-content">{{item.name}}&nbsp;&nbsp;</span>
                  </div>
                
                 <span v-else class="bold-content">{{$parent.game.label | label}}</span>
                </mu-col>
                   
              </mu-row>
              -->
              <br>
              <mu-row><mu-col style="height:70px;width:100%;margin-bottom: 20px;">
                <span class="title-style"  v-if="game.desc!='康复1.0言语游戏移植'">
                   <p v-for='item in logionList'style='font-size:14px'>{{item}}</p>   
                    <p style='font-size:14px;text-align:right;margin-right: 8px;'>{{list[list.length-1]}}</p>   
                </span><br>
                <span class="desc-content" v-if="game.desc=='康复1.0言语游戏移植'">&nbsp;</span>
                <!--<span class="desc-content" v-else>{{game.desc}}</span>-->
              </mu-col></mu-row>
              <br>
              <mu-row><mu-col>
                <div v-if="game.id>100" >
                  <span class="title-style">生活解读</span><br>
                  <!--<span v-for="item in game.label_desc" class="desc-content">{{item.name}}：{{item.desc}}<br></span>-->
                  <span  class="desc-content" style='font-size:14px;'>{{game.life_interpretation}}<br></span>
                </div>
                <!-- <span v-else class="desc-content">{{$parent.game.label | desc}}</span> -->
              </mu-col></mu-row>
            </mu-col>
            <mu-col>
              <div>
                <trainCronSave v-if="saveGame"
                :gameData="game"
                :gameFlag="gameFlag"
                :caseId="$parent.caseId"
                :caseName="$parent.caseName"
                :todayGames="todayGames"
                @restart="restartLanTrain"
                @updateScore="getGameScore"
                @close="saveGame=false"></trainCronSave>
                <verbalGames v-if="showVerbal"
                ref="verbalM"
                @verbalEvent="verbalFun"
                :gameData="game"
                ></verbalGames>
              </div>
            </mu-col>
          </mu-row>
        </mu-col>
      </mu-row>
      <mu-raised-button label="取消" @click="cancelGame" style=" margin-left:20px;margin-right:20px;" slot="actions" />
     <!-- <mu-raised-button v-if="game.lesson_type=='l'" label="30秒体验" @click="openGame(0)"  slot="actions" primary />
      <mu-raised-button v-if='' label="30秒体验" @click="openGame(0)"  slot="actions" primary />-->
      <mu-raised-button  label="30秒体验" @click="openGame(0)" style=" margin-left:24px;margin-right:40px;" slot="actions" primary />
    </mu-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import trainCronSave from '../../common/trainCronSave.vue'
  import gameOver from '../../common/gameOver.vue'
  import level from '../../common/levels.vue'
  import verbalGames from './verbalGames.vue'
 

  export default ({
    props:["game"],
    data() {
      return {
        address: GLOBAL.cognition,
        showDialog: true,
        showOver: false,
        saveGame: false,  // 打开1.0游戏并保存
        showMes: false,   // 显示消息框
        gameType: 1,   // 1:认知，2：言语
        gameFlag: 0,      // 0：临时训练； 1：正式训练
        gameData: this.game,       // 游戏数据
        gameScore: {},
        todayGames: '',
        showVerbal:false,
        logionList:[],
        list:[],
      }
    },
    filters: {
      label: function(val){
        let name = [];
        let labels = GLOBAL.trainClass;
        let lan = val.split(',');
        for(let key in labels){
          for(let j=0; j<lan.length; j++){
            if(labels[key].id == lan[j]){
              name.push(labels[key].name)
            }
          }
        }
        return name.join(",");
      },
      desc: function(val){
        let name = [];
        let labels = GLOBAL.trainClass;
        let lan = val.split(',');
        for(let key in labels){
          for(let j=0; j<lan.length; j++){
            if(labels[key].id == lan[j]){
              name.push(labels[key].desc)
            }
          }
        }
        return name.join("———\r\n");
      }
    },
    components:{
      trainCronSave,
      level,
      gameOver,
      verbalGames,

    },
    mounted(){
      //设置名言
       this.list=this.game.logion.split('##');
      var end=this.list.length-1;
     // console.log(this.list.slice(0,end));
     this.logionList=this.list.slice(0,end);
    //console.log(this.logionList);
    console.log(this.game)
    },
    methods: {
      openGame: function(res){
        if(this.$parent.caseId || res == 0){
          this.gameFlag = res;
          this.saveGame = true;
        } else {
          this.showMes = true;
        }
      },
      verbalFun(){
        this.cancelGame();
      },
      openGame1(game){
        this.showVerbal = true;
        this.saveGame = false;
      },
      cancelGame: function(){
        this.saveGame = false;
        this.showVerbal = false;//
        this.$emit("close2");
        this.$parent.caseId = '';
      },
      getGameScore: function(res,name){
        console.log(">>>>>>>>>>>>>>>>>>>>>");
        console.log(res);
        console.log(name);
        this.gameType = 1;
        this.showOver = true;
        this.saveGame = false;
        this.gameScore = res;
        this.gameScore['name'] = name;
      },
      closeGame: function(){
        this.showOver = false;
      },
      restartLanTrain: function(item){
        console.log(item)
        this.gameType = 2;
        this.showOver = true;
        this.saveGame = false;
        this.gameScore = item;
      },
      // 再练习一次
      restartTrain: function(){
        this.showOver = false;
        this.saveGame = true;
      },
      beginTrain:function(game){
        var self = this;
        this.showDialog = false;
        Vue.http({
          method: 'GET',
          url:'/api/Train/getDailyTrainingProgram',
          params: {
            'id': self.$route.params.id
          }
        })
          .then(function(data){
            self.$parent.gameData = game;
            self.$parent.saveGame = true;
            self.$parent.showContentModal = false;
          })
      }
    }
  });
</script>

<style scoped>
  .title-style{
    font-size: 12px;
    color: #999;
  }
  .bold-content{
    font-size: 14px;
    font-weight: bold;
  }
  .desc-content{
    font-size: 14px;
  }

</style>
<style>
.diaTrainContent{
  width:768px !important;
  max-width:768px !important;
  height:425px !important;
  max-height:425px !important;
}
.canWidth{
  min-width:150px;
}
</style>




// WEBPACK FOOTER //
// cognTrainIntroduction.vue?7989188a